import convert from 'convert-units';

export const NO_DATA = '-';

// CONVERT CONSTANTS
export const VALID_UNITS = convert().possibilities();

export const A = 'A';
export const KG = 'kg';
export const KM = 'km';
export const KW = 'kW';
export const KWH = 'kWh';
export const M = 'm';
export const MA = 'mA';
export const MI = 'mi';
export const MIN = 'min';
export const MS = 'ms';
export const MV = 'mV';
export const MW = 'MW';
export const MWH = 'MWh';
export const S = 's';
export const V = 'V';
export const W = 'W';
export const WH = 'Wh';

export const K_LABEL = `${KW}/${KWH}`;
export const M_LABEL = `${MW}/${MWH}`;

export const REQUESTED_UOM_PARAMETER = 'requestedUoM';

// MISC
export const distanceMapper = {
  miles: MI,
  kilometers: KM,
};

export const PERCENTAGE_MEASURE = '%';

export default {
  A,
  distanceMapper,
  KG,
  KM,
  KW,
  KWH,
  M,
  MA,
  MI,
  MIN,
  MS,
  MV,
  MW,
  MWH,
  NO_DATA,
  PERCENTAGE_MEASURE,
  REQUESTED_UOM_PARAMETER,
  S,
  V,
  VALID_UNITS,
  W,
  WH,
};
